

const CheckRule = (rule, data) => {

    if (rule.Field === undefined || rule.Field === "") { return true; }

    const key = Object.keys(data).find(key => key.toLowerCase() === rule.Field.toLowerCase());

    if (key === undefined) { return rule.Rule !== "=" && rule.Rule !== "isnotempty"; }
    
    const value = data[key];

    switch (rule.Rule.toLowerCase()) {
        case "isnotempty":
            return value !== undefined && value !== null && value.toString() !== ""
        case "isempty":
            return value === undefined || value === null || value.toString() === "";
        case "=":
            //return value !== undefined && value !== null && value.toString() === rule.Value;
            return value !== undefined && value !== null && CompareValueString(value.toString(), rule.Value);
        case "!=":
            return value === undefined || value === null || value.toString() !== rule.Value;
        default:
            return true;
    }
}

const CompareValueString = (valueToCompare, ruleValue) => {
    const values = ruleValue.split(",");

    for (const val of values) {
        if (val.trim() === valueToCompare) {
            return true;
        }
    }
    return false;
}

export default CheckRule;
